import { redondear } from '../dinero';

export interface EntradaPagoSemanal {
  sueldoSemanal: number | null;
  minutosTrabajados: number;
  minutosProgramados: number;
  comisionesServicios: number;
  comisionesProductos: number;
  propinas: number;
  faltantesADescontar: number;
  ajustes: number;
}

export interface PagoSemanalCalculo {
  sueldoBase: number;
  ajusteTiempo: number;
  comisionServicios: number;
  comisionProductos: number;
  propinas: number;
  descuentoFaltantes: number;
  ajustesManuales: number;
  total: number;
}

/**
 * Pago semanal: sueldo proporcional al tiempo trabajado (sin exceder el sueldo), más comisiones
 * y propinas, menos los faltantes de caja que el dueño decida descontar.
 */
export function calcularPagoSemanal(e: EntradaPagoSemanal): PagoSemanalCalculo {
  const sueldoBase = e.sueldoSemanal ?? 0;
  const proporcion = e.minutosProgramados > 0 ? Math.min(1, e.minutosTrabajados / e.minutosProgramados) : 1;
  const ajusteTiempo = redondear(sueldoBase * proporcion) - sueldoBase;
  const total = sueldoBase + ajusteTiempo + e.comisionesServicios + e.comisionesProductos + e.propinas - e.faltantesADescontar + e.ajustes;
  return {
    sueldoBase,
    ajusteTiempo,
    comisionServicios: e.comisionesServicios,
    comisionProductos: e.comisionesProductos,
    propinas: e.propinas,
    descuentoFaltantes: e.faltantesADescontar,
    ajustesManuales: e.ajustes,
    total,
  };
}
